module.exports = __webpack_public_path__ + "img/quxiao.c5761daf.png";